import { useRouter } from 'next/router';
import { useEffect } from 'react';

import { QUERY_KEY, TOKEN_SCOPE, useServiceAppState } from '@kc-console/context';
import { STATUS_CODE } from '@kc-console/core';

/**
 * url에 필수 쿼리파라미터를 추가하는 훅입니다.
 * @description
 * - domain scope일 경우 domain_id, region이 없을 경우 각각의 값을 쿼리파라미터에 추가합니다.
 * - project scope일 경우 project_id, region이 없을 경우 각각의 값을 쿼리파라미터에 추가합니다.
 */
const useRequiredParamEffect = () => {
  const router = useRouter();
  const { query } = router;
  const {
    state: { domainId, projectId, region, scope, status },
  } = useServiceAppState();

  // scope 에 따른 query update. (project_id, domain_id, region)
  useEffect(() => {
    if (status !== STATUS_CODE.OK) return;
    if (scope === TOKEN_SCOPE.DOMAIN) {
      const newQuery = { ...query };
      const invalid = !query[QUERY_KEY.DOMAIN_ID];

      if (domainId) newQuery[QUERY_KEY.DOMAIN_ID] = domainId;
      if (region) newQuery[QUERY_KEY.REGION] = region;

      if (invalid) {
        router.replace(
          {
            pathname: router.pathname,
            query: { ...newQuery },
          },
          '',
          { shallow: true },
        );
      }
    } else if (scope === TOKEN_SCOPE.PROJECT) {
      const newQuery = { ...query };
      const invalid = !query[QUERY_KEY.PROJECT_ID] || !query[QUERY_KEY.REGION];

      if (projectId) newQuery[QUERY_KEY.PROJECT_ID] = projectId;
      if (region) newQuery[QUERY_KEY.REGION] = region;

      if (invalid) {
        router.replace(
          {
            pathname: router.pathname,
            query: { ...newQuery },
          },
          '',
          { shallow: true },
        );
      }
    }
  }, [scope, domainId, region, projectId, query, router, status]);
};

export default useRequiredParamEffect;
